import React from 'react';
import RxOp from 'rxjs-operators';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';

import dashboardService from 'services/dashboard';
import Snackbar from 'components/Shared/Snackbar';

type SendScreenshotProps = {
  dataUrl: Blob;
  open: boolean;
  onClose: () => void;
};

export default function SendScreenshot({
  dataUrl,
  open,
  onClose,
}: SendScreenshotProps) {
  const [email, setEmail] = React.useState('');
  const [isSending, setIsSending] = React.useState(false);

  const handleSendEmail = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setIsSending(true);
    const formattedData = new FormData();
    const file = new File([dataUrl], 'screenshot.png', { type: 'image/png' });

    formattedData.append('email', email);
    formattedData.append('file', file);

    dashboardService
      .sendScreenshot(formattedData)
      .pipe(RxOp.logError())
      .subscribe(
        () => {
          Snackbar.show(`O print foi enviado para ${email}`);
          setEmail('');
          onClose();
        },
        () => {
          Snackbar.show('Houve um erro ao enviar o print. Tente novamente.');
        }
      );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="send-screenshot-dialog-title"
      aria-describedby="send-screenshot-dialog-description"
    >
      <DialogTitle id="send-screenshot-dialog-title">Enviar print</DialogTitle>
      <form onSubmit={handleSendEmail}>
        <DialogContent>
          <DialogContentText id="send-screenshot-dialog-description">
            Insira o email para enviar o print
          </DialogContentText>

          <TextField
            type="email"
            label="Email"
            inputMode="email"
            size="small"
            margin="dense"
            fullWidth
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button type="submit" color="primary" disabled={!email || isSending}>
            {isSending ? 'Enviando...' : 'Enviar'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
